import React, {useContext} from 'react';
import styled from 'styled-components';
import CheckBox from '../../../CheckBox/CheckBox';
import {QuestionAnswers} from '../../../../context';


const SelectQuestion = ({choices=[],text,handleChange,questionKey}) => {
  const {[questionKey]:value=[]} = useContext(QuestionAnswers);

  function addToSelection(item) {
    handleChange([...value,item]);
  }

  function removeFromSelection(item) {
    const filteredSelections = value.filter(selection => selection !== item);
    handleChange(filteredSelections);
  }

  const list = choices.map(item => (
    <ChoiceWrapper key={`choice_${item}`}>
      {value.includes(item) ? (
        <SelectedOption onClick={() => removeFromSelection(item)}>
          <CheckBox/>
        </SelectedOption>
      ) : <EmptyOption onClick={() => addToSelection(item)} />}
      {item}
    </ChoiceWrapper>
  ))

  return (
    <div>
      <p>{text}</p>
      <br/>
      <p>Select all that apply:</p>
      {list}
    </div>
  );
};

const EmptyOption = styled.div`
  width: 25px;
  height: 25px;
  border: 1px solid #999;
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
  margin-right: 20px;
  border-radius: 2px;
`;

const SelectedOption = styled.div`
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
  margin-right: 20px;
`;

const ChoiceWrapper = styled.div`
  height: 25px;
  line-height: 25px;
  margin-bottom: 15px;
  padding-left: 40px;
  user-select: none;
`;

export default SelectQuestion;
